export default { sha: 'a67c0a927fef793ace425ac16497e040a03f956f', buildNumber: 'undefined' }
